/**
@format
@flow
*/
import React from 'react';
import styled from 'styled-components';
import Squircle from '@ziynx/components/squircles';
import type { TextType } from '@ziynx/flow-types/typography';
import type { IconType } from '@ziynx/flow-types/icons';

export type Props = $ReadOnly<{|
    /**
     *  Disabled prop for Squircle Button
     */
    disabled?: boolean,

    /**
     * If button is inverted, default is white.
     */
    inverted?: boolean,

    /**
     * Inverted color
     */
    invertedColor?: string,

    /**
     * Depicts when button is in loading state
     */
    isLoading?: boolean,

    /**
     * Href for button as a link
     */
    href?: string,

    /**
     * Target for href
     */
    target?: '_blank' | '_self',

    /**
     * Icon for the button
     */
    icon?: IconType,

    /**
     * Size of the squircle
     */
    size?: 'extraSmall' | 'small' | 'medium' | 'large' | 'extraLarge' | 'extraExtraLarge',

    /**
     * Background color
     */
    backgroundColor?: string,

    /**
     * Border color
     */
    borderColor?: string,

    /**
     * No shadow if true
     */
    noShadow?: boolean,

    /**
     * Text for withText options
     */
    text?: TextType,

    /**
     * Overlay text
     */
    overlayText?: string,

    /**
     * Children passed in
     */
    children?: any,

    /**
     * onClick
     */
    onClick?: (event?: SyntheticEvent<HTMLButtonElement | HTMLAnchorElement>) => any | Promise<any>;

|}>;

const Button = styled.button`
    display: inherit;
    width: auto;
    height: auto;
    background-color: transparent;
    padding: 0px;
    border: none;
    cursor: pointer;
`;

const ButtonSquircle = (props: Props): React$Node => {
  const {
    onClick, text, icon, disabled, ...rest
  } = props;

  return (
    <Button
      disabled={disabled}
      onClick={onClick}
    >
      <Squircle
        {...rest}
        disabled={disabled}
        text={text?.text}
        color={icon?.color || text?.color}
        iconName={icon?.name}
      />
    </Button>
  );
};

export default ButtonSquircle;
